/*                                                         */
/*         */
/*                                 */
import { get_current_component } from "svelte/internal";

export function useAria(ariaProp: Record<string, string>): void {
  const component = get_current_component();

  const { root } = component.$$;
  const { host } = root as { host: HTMLElement };
  Object.entries(ariaProp).forEach(([key, value]) => {
    host.setAttribute(`aria-${key}`, value);
  });
}
